import { isPurchaseCreditsRow, ledgerDisplayStatus, resolveUsdPeriodDateRange } from './ledgerUtils';
function rowCreatedTime(row) {
    var _a;
    const raw = (_a = row.created_at) !== null && _a !== void 0 ? _a : row.createdAt;
    if (!raw)
        return null;
    const t = new Date(raw).getTime();
    return Number.isFinite(t) ? t : null;
}
export function filterUsdLedgerRows(rows, filters) {
    const q = filters.query.trim().toLowerCase();
    const { dateFrom, dateTo } = resolveUsdPeriodDateRange(filters.period, filters.dateFrom, filters.dateTo);
    const fromMs = dateFrom ? new Date(`${dateFrom}T00:00:00`).getTime() : null;
    const toMs = dateTo ? new Date(`${dateTo}T23:59:59.999`).getTime() : null;
    return rows.filter((r) => {
        if (filters.typeFilter !== 'all') {
            if (filters.typeFilter === 'purchase_credits') {
                if (!isPurchaseCreditsRow(r))
                    return false;
            }
            else if (filters.typeFilter === 'withdrawal') {
                const t = String(r.type || '').toLowerCase();
                if (t !== 'withdrawal' || isPurchaseCreditsRow(r))
                    return false;
            }
            else {
                const t = String(r.type || '').toLowerCase();
                if (t !== filters.typeFilter)
                    return false;
            }
        }
        const st = ledgerDisplayStatus(r);
        if (filters.statusFilter !== 'all' && st !== filters.statusFilter)
            return false;
        const created = rowCreatedTime(r);
        if (fromMs != null && Number.isFinite(fromMs) && created != null && created < fromMs)
            return false;
        if (toMs != null && Number.isFinite(toMs) && created != null && created > toMs)
            return false;
        if (!q)
            return true;
        const metaStr = r.metadata ? JSON.stringify(r.metadata).toLowerCase() : '';
        const hay = [
            r.id,
            r.transactionId,
            r.referenceType,
            r.referenceId,
            r.provider,
            r.type,
            r.status,
            metaStr,
        ]
            .filter(Boolean)
            .join(' ')
            .toLowerCase();
        return hay.includes(q);
    });
}
export const defaultUsdLedgerFilters = () => {
    const { dateFrom, dateTo } = resolveUsdPeriodDateRange('today', '', '');
    return {
        period: 'today',
        dateFrom,
        dateTo,
        query: '',
        typeFilter: 'all',
        statusFilter: 'all',
    };
};
